import Vue from 'vue';
import ServicesWebApp from '~/pages/services/web-app.vue';
import RasylvaApi from '~/plugins/rasylva-api';
import createStore from '~/store';

Vue.use(RasylvaApi);

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('services-web-app-wrapper')) {
    new Vue({
      store: createStore(),
      render: (h) => h(ServicesWebApp),
    }).$mount('#services-web-app-wrapper');
  }
});
